// @ts-ignore
import ApiClient from '../api-client/apiClient';
// @ts-ignore
import { PORT, apiUrl, version } from '../environment';
// @ts-ignore
import { getAccessToken } from '../auth';
import { GET_PLATFORMS_SUCCESS, GET_PLATFORMS_FAILURE, APPROVE_PLATFORM_SUCCESS, APPROVE_PLATFORM_FAILURE, REJECT_PLATFORM_SUCCESS, REJECT_PLATFORM_FAILURE } from '../constants/actionTypes';

export const rejectPlatform = (id: string) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        return ApiClient.put(`${apiUrl}${PORT}${version}/platform/${id}/reject`, {}, token, dispatch).then(
            (response: any) => {
                if (response.status === 200) {
                    dispatch({ type: REJECT_PLATFORM_SUCCESS, payload: response });
                    return response;
                } else {
                    dispatch({ type: REJECT_PLATFORM_FAILURE, payload: response.message });
                    return Promise.reject(response);
                }
            }
        ).catch((error: any) => {
            dispatch({ type: REJECT_PLATFORM_FAILURE, payload: error.message });
            return Promise.reject(error);
        });
    };
};

export const approvePlatform = (id: string) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        return ApiClient.put(`${apiUrl}${PORT}${version}/platform/${id}/approve`, {}, token, dispatch).then(
            (response: any) => {
                if (response.status === 200) {
                    dispatch({ type: APPROVE_PLATFORM_SUCCESS, payload: response });
                    return response;
                } else {
                    dispatch({ type: APPROVE_PLATFORM_FAILURE, payload: response.message });
                    return Promise.reject(response);
                }
            }
        ).catch((error: any) => {
            dispatch({ type: APPROVE_PLATFORM_FAILURE, payload: error.message });
            return Promise.reject(error);
        });
    };
};

export const getPlatforms = (params: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/super-admin/platforms`, params, token, dispatch).then(
            (response: any) => {
                if (response.status === 200) {
                    dispatch({ type: GET_PLATFORMS_SUCCESS, payload: response });
                } else {
                    dispatch({ type: GET_PLATFORMS_FAILURE, payload: response.message });
                }
            }
        ).catch((error: any) => {
             dispatch({ type: GET_PLATFORMS_FAILURE, payload: error.message });
        });
    };
};
